function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.1402 6.19354L7.72687 8.7802L10.3135 6.19354C10.5735 5.93354 10.9935 5.93354 11.2535 6.19354C11.5135 6.45354 11.5135 6.87354 11.2535 7.13354L8.19354 10.1935C7.93354 10.4535 7.51354 10.4535 7.25354 10.1935L4.19354 7.13354C3.93354 6.87354 3.93354 6.45354 4.19354 6.19354C4.45354 5.9402 4.8802 5.93354 5.1402 6.19354Z",
  fill: "#303030"
});
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.8286b3dfc37b8ec271cd11809f1b9b56.svg";
export { ForwardRef as ReactComponent };